export const LANGUAGES = [
  'English',
  'Hindi',
  'Bengali',
  'Gujarati',
  'Kannada',
  'Malayalam',
  'Marathi',
  'Punjabi',
  'Tamil',
  'Telugu',
  'Urdu',
];
